import {
  GET_REQUEST_FLOWS,
  GET_REQUEST_FLOWS_SUCCESS,
  GET_REQUEST_FLOWS_FAILURE,
  GET_REQUEST_LIST,
  GET_REQUEST_LIST_SUCCESS,
  GET_REQUEST_LIST_FAILURE,
  CANCEL_MY_REQUEST,
  CANCEL_MY_REQUEST_FAILURE,
  CANCEL_MY_REQUEST_SUCCESS,
  APPROVE_REQUEST,
  APPROVE_REQUEST_SUCCESS,
  APPROVE_REQUEST_FAILURE,
  REJECT_REQUEST,
  REJECT_REQUEST_SUCCESS,
  REJECT_REQUEST_FAILURE,
  RESET_REQUEST_MESSAGE,
  GET_REQUEST_LIST_EMPTY, GET_PENDING_REQUEST_LIST, GET_PENDING_REQUEST_LIST_SUCCESS, GET_PENDING_REQUEST_LIST_FAILURE
} from './actions';

const initialState = {
  loading: true,
  requestFlowData: [],
  requestListData: [],
  pendingRequestListData: [],
  pendingRequestLoading: true,
  cancelRequestLoading: false,
  isCancelRequestSuccess: null,
  approveRequestLoading: false,
  isApproveRequestSuccess: null,
  rejectRequestLoading: false,
  isRejectRequestSuccess: null,
  messageType: null,
  lastMessage: null,
  error: "",
  cancelResponse: null,
  approveResponse: null,
  rejectResponse: null
}

export function requestMessageReducer(state = initialState, action) {
  let data = action.payload;

  switch (action.type) {
    case GET_REQUEST_FLOWS:
      return {
        ...state,
        requestFlowData: [],
        loading: true,
        error: ""
      }

    case GET_REQUEST_FLOWS_SUCCESS:
      return {
        ...state,
        requestFlowData: data,
        loading: false
      }

    case GET_REQUEST_FLOWS_FAILURE:
      return {
        ...state,
        requestFlowData: [],
        loading: false,
        error: "Error with get request flows."
      }

    case GET_REQUEST_LIST:
      return {
        ...state,
        requestListData: [],
        loading: true,
        error: ""
      }

    case GET_REQUEST_LIST_SUCCESS:
      return {
        ...state,
        requestListData: data,
        loading: false,
        error: ""
      }

    case GET_REQUEST_LIST_FAILURE:
      return {
        ...state,
        requestListData: [],
        loading: false,
        error: "Error with get request list."
      }


    case GET_REQUEST_LIST_EMPTY:
      return {
        ...state,
        requestListData: [],
        loading: false,
        error: "No request found."
      }
    case GET_PENDING_REQUEST_LIST:
      return {
        ...state,
        pendingRequestListData: [],
        pendingRequestLoading: true,
        error: ""
      }

    case GET_PENDING_REQUEST_LIST_SUCCESS:
      return {
        ...state,
        pendingRequestListData: data,
        pendingRequestLoading: false,
        error: ""
      }

    case GET_PENDING_REQUEST_LIST_FAILURE:
      return {
        ...state,
        pendingRequestListData: [],
        pendingRequestLoading: false,
        error: "Error with get pending request list."
      }

    case CANCEL_MY_REQUEST:
      return {
        ...state,
        cancelRequestLoading: true
      }
    case CANCEL_MY_REQUEST_SUCCESS:
      return {
        ...state,
        cancelRequestLoading: false,
        isCancelRequestSuccess: true,
        messageType: "cancel",
        lastMessage: `Cancelled request successful: ${data.message}`,
        cancelResponse: data
      }
    case CANCEL_MY_REQUEST_FAILURE:
      return {
        ...state,
        cancelRequestLoading: false,
        isCancelRequestSuccess: false,
        updateProductResult: null,
        messageType: 'error',
        lastMessage: data?.message
      }
    case APPROVE_REQUEST:
      return {
        ...state,
        approveRequestLoading: true
      };

    case APPROVE_REQUEST_SUCCESS:
      return {
        ...state,
        approveRequestLoading: false,
        isApproveRequestSuccess: true,
        messageType: "approve",
        lastMessage: `Approved request successful: ${data.message}`,
        approveResponse: data
      };

    case APPROVE_REQUEST_FAILURE:
      return {
        ...state,
        approveRequestLoading: false,
        isApproveRequestSuccess: false,
        messageType: 'error',
        lastMessage: data?.message
      };

    case REJECT_REQUEST:
      return {
        ...state,
        rejectRequestLoading: true
      };

    case REJECT_REQUEST_SUCCESS:
      return {
        ...state,
        rejectRequestLoading: false,
        isRejectRequestSuccess: true,
        messageType: "reject",
        lastMessage: `Rejected request successful: ${data.message}`,
        rejectResponse: data
      };

    case REJECT_REQUEST_FAILURE:
      return {
        ...state,
        rejectRequestLoading: false,
        isRejectRequestSuccess: false,
        messageType: 'error',
        lastMessage: data?.message
      };

    case RESET_REQUEST_MESSAGE:
      return {
        ...state,
        messageType: null,
        lastMessage: null
      };

    default:
      return state;
  }
}
